if (document.getElementById('rule-modal') !== null) {
    var ruleModal = new bootstrap.Modal('#rule-modal', {})
    ruleModal.show()
}

$('[data-scroll_down_target]').each(function () {
    var $scroll = $(this);
    var $target = $scroll.closest('.rule-modal').find($scroll.data('scroll_down_target'));
    $scroll.scroll(function () {
        var enable = $scroll[0].scrollHeight > 0
            && $scroll[0].scrollHeight <= $scroll.scrollTop() + $scroll.innerHeight() + 50
        if (enable) {
            setTimeout(function () {
                $target.attr('disabled', null)
            }, 300);
        }
    }).scroll();
})